var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.internalValue),function(item,i){return _c('os-input-checkbox',{key:i,attrs:{"label":item.label,"readonly":_vm.readonly},model:{value:(item.isSelected),callback:function ($$v) {_vm.$set(item, "isSelected", $$v)},expression:"item.isSelected"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }